import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { SettingsComponent } from '../settings/settings.component';
import { menuData } from './hamerburg-menu-data';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { AccountOptionPage } from '../../modal-screens/account-option/account-option.page';
import { Observable } from 'rxjs';
import { PlayerInfo } from 'src/data/mygolf.data';
import { PlayerHomeActions } from 'src/redux/player-home';

@Component({
  selector: 'app-hamerburg-menu',
  templateUrl: './hamerburg-menu.component.html',
  styleUrls: ['./hamerburg-menu.component.scss'],
})
export class HamerburgMenuComponent implements OnInit {

  @Input() teeSlotNew: boolean = false;
  @Input() isMoreOption: boolean = true;
  @Input() dataList: Array<any> = [];

  constructor(
    private modalCtl: ModalController,
    private router: Router,
    private platform: Platform,
    private flightService: ClubFlightService,
    private playerHomeActions: PlayerHomeActions
  ) {

    console.log(this.teeSlotNew,'teeSlotNew 1', this.dataList)
  }

  ngOnInit() {
    console.log(this.teeSlotNew,'teeSlotNew 2')
  }

    // Close Modal menu
    backButton() {
      this.modalCtl.dismiss();
    }

    menuSelectItem(id:any){
      let obj = {
        id: id
      }
      this.modalCtl.dismiss(obj);
    }

    getItemVisible(id: number) {
      if(!this.dataList || this.dataList?.length === 0) return true;
      return this.dataList.find((data)=>{
        return data.id === id && data?.visible
      })
    }

    getItemLabel(id: number) {
      if(!this.dataList || this.dataList?.length === 0) return;
      return this.dataList.find((data)=>{
        return data.id === id && data?.visible
      })?.name
    }
}
